// GENERADO por backend/scripts/build-divipola-municipios.js — NO EDITAR A MANO.
// Fuente: DANE DIVIPOLA «Códigos municipios», dataset gdxc-w37w (datos.gov.co, datos abiertos).
//   https://www.datos.gov.co/Mapas-Nacionales/DIVIPOLA-C-digos-municipios/gdxc-w37w
// Generado el 2026-08-24. 1122 entradas (Municipios + Isla + Áreas no municipalizadas).
// Cada entrada: { c: código DANE (5 díg), m: municipio, d: departamento, s: ISO del departamento }.
// s = código ISO 3166-2:CO del departamento, IDÉNTICO a la clave billing_state de WooCommerce
//   (i18n/states.php, 'CO'). El checkout filtra municipios por este ISO sin traducir nombres.
//   El mapa nombre→ISO vive en el generador (backend/scripts/build-divipola-municipios.js).
// El código DANE (c) es la MARCA de "elegido de la lista": un valor escrito a mano no lo lleva.

const MUNICIPIOS = [
  { c: '05002', m: "Abejorral", d: "Antioquia", s: 'CO-ANT' },
  { c: '54003', m: "Ábrego", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05004', m: "Abriaquí", d: "Antioquia", s: 'CO-ANT' },
  { c: '50006', m: "Acacías", d: "Meta", s: 'CO-MET' },
  { c: '27006', m: "Acandí", d: "Chocó", s: 'CO-CHO' },
  { c: '41006', m: "Acevedo", d: "Huila", s: 'CO-HUI' },
  { c: '13006', m: "Achí", d: "Bolívar", s: 'CO-BOL' },
  { c: '41013', m: "Agrado", d: "Huila", s: 'CO-HUI' },
  { c: '25001', m: "Agua de Dios", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '20011', m: "Aguachica", d: "Cesar", s: 'CO-CES' },
  { c: '68013', m: "Aguada", d: "Santander", s: 'CO-SAN' },
  { c: '17013', m: "Aguadas", d: "Caldas", s: 'CO-CAL' },
  { c: '85010', m: "Aguazul", d: "Casanare", s: 'CO-CAS' },
  { c: '20013', m: "Agustín Codazzi", d: "Cesar", s: 'CO-CES' },
  { c: '41016', m: "Aipe", d: "Huila", s: 'CO-HUI' },
  { c: '25019', m: "Albán", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52019', m: "Albán", d: "Nariño", s: 'CO-NAR' },
  { c: '18029', m: "Albania", d: "Caquetá", s: 'CO-CAQ' },
  { c: '44035', m: "Albania", d: "La Guajira", s: 'CO-LAG' },
  { c: '68020', m: "Albania", d: "Santander", s: 'CO-SAN' },
  { c: '76020', m: "Alcalá", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '52022', m: "Aldana", d: "Nariño", s: 'CO-NAR' },
  { c: '05021', m: "Alejandría", d: "Antioquia", s: 'CO-ANT' },
  { c: '47030', m: "Algarrobo", d: "Magdalena", s: 'CO-MAG' },
  { c: '41020', m: "Algeciras", d: "Huila", s: 'CO-HUI' },
  { c: '19022', m: "Almaguer", d: "Cauca", s: 'CO-CAU' },
  { c: '15022', m: "Almeida", d: "Boyacá", s: 'CO-BOY' },
  { c: '73024', m: "Alpujarra", d: "Tolima", s: 'CO-TOL' },
  { c: '41026', m: "Altamira", d: "Huila", s: 'CO-HUI' },
  { c: '27025', m: "Alto Baudó", d: "Chocó", s: 'CO-CHO' },
  { c: '13030', m: "Altos del Rosario", d: "Bolívar", s: 'CO-BOL' },
  { c: '73026', m: "Alvarado", d: "Tolima", s: 'CO-TOL' },
  { c: '05030', m: "Amagá", d: "Antioquia", s: 'CO-ANT' },
  { c: '05031', m: "Amalfi", d: "Antioquia", s: 'CO-ANT' },
  { c: '73030', m: "Ambalema", d: "Tolima", s: 'CO-TOL' },
  { c: '25035', m: "Anapoima", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52036', m: "Ancuya", d: "Nariño", s: 'CO-NAR' },
  { c: '76036', m: "Andalucía", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '05034', m: "Andes", d: "Antioquia", s: 'CO-ANT' },
  { c: '05036', m: "Angelópolis", d: "Antioquia", s: 'CO-ANT' },
  { c: '05038', m: "Angostura", d: "Antioquia", s: 'CO-ANT' },
  { c: '25040', m: "Anolaima", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '05040', m: "Anorí", d: "Antioquia", s: 'CO-ANT' },
  { c: '17042', m: "Anserma", d: "Caldas", s: 'CO-CAL' },
  { c: '76041', m: "Ansermanuevo", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '05044', m: "Anzá", d: "Antioquia", s: 'CO-ANT' },
  { c: '73043', m: "Anzoátegui", d: "Tolima", s: 'CO-TOL' },
  { c: '05045', m: "Apartadó", d: "Antioquia", s: 'CO-ANT' },
  { c: '66045', m: "Apía", d: "Risaralda", s: 'CO-RIS' },
  { c: '25599', m: "Apulo", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15047', m: "Aquitania", d: "Boyacá", s: 'CO-BOY' },
  { c: '47053', m: "Aracataca", d: "Magdalena", s: 'CO-MAG' },
  { c: '17050', m: "Aranzazu", d: "Caldas", s: 'CO-CAL' },
  { c: '68051', m: "Aratoca", d: "Santander", s: 'CO-SAN' },
  { c: '81001', m: "Arauca", d: "Arauca", s: 'CO-ARA' },
  { c: '81065', m: "Arauquita", d: "Arauca", s: 'CO-ARA' },
  { c: '25053', m: "Arbeláez", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52051', m: "Arboleda", d: "Nariño", s: 'CO-NAR' },
  { c: '54051', m: "Arboledas", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05051', m: "Arboletes", d: "Antioquia", s: 'CO-ANT' },
  { c: '15051', m: "Arcabuco", d: "Boyacá", s: 'CO-BOY' },
  { c: '13042', m: "Arenal", d: "Bolívar", s: 'CO-BOL' },
  { c: '05055', m: "Argelia", d: "Antioquia", s: 'CO-ANT' },
  { c: '19050', m: "Argelia", d: "Cauca", s: 'CO-CAU' },
  { c: '76054', m: "Argelia", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '47058', m: "Ariguaní", d: "Magdalena", s: 'CO-MAG' },
  { c: '13052', m: "Arjona", d: "Bolívar", s: 'CO-BOL' },
  { c: '05059', m: "Armenia", d: "Antioquia", s: 'CO-ANT' },
  { c: '63001', m: "Armenia", d: "Quindío", s: 'CO-QUI' },
  { c: '73055', m: "Armero", d: "Tolima", s: 'CO-TOL' },
  { c: '13062', m: "Arroyohondo", d: "Bolívar", s: 'CO-BOL' },
  { c: '20032', m: "Astrea", d: "Cesar", s: 'CO-CES' },
  { c: '73067', m: "Ataco", d: "Tolima", s: 'CO-TOL' },
  { c: '27050', m: "Atrato", d: "Chocó", s: 'CO-CHO' },
  { c: '23068', m: "Ayapel", d: "Córdoba", s: 'CO-COR' },
  { c: '27073', m: "Bagadó", d: "Chocó", s: 'CO-CHO' },
  { c: '27075', m: "Bahía Solano", d: "Chocó", s: 'CO-CHO' },
  { c: '27077', m: "Bajo Baudó", d: "Chocó", s: 'CO-CHO' },
  { c: '19075', m: "Balboa", d: "Cauca", s: 'CO-CAU' },
  { c: '66075', m: "Balboa", d: "Risaralda", s: 'CO-RIS' },
  { c: '08078', m: "Baranoa", d: "Atlántico", s: 'CO-ATL' },
  { c: '41078', m: "Baraya", d: "Huila", s: 'CO-HUI' },
  { c: '52079', m: "Barbacoas", d: "Nariño", s: 'CO-NAR' },
  { c: '05079', m: "Barbosa", d: "Antioquia", s: 'CO-ANT' },
  { c: '68077', m: "Barbosa", d: "Santander", s: 'CO-SAN' },
  { c: '68079', m: "Barichara", d: "Santander", s: 'CO-SAN' },
  { c: '50110', m: "Barranca de Upía", d: "Meta", s: 'CO-MET' },
  { c: '68081', m: "Barrancabermeja", d: "Santander", s: 'CO-SAN' },
  { c: '44078', m: "Barrancas", d: "La Guajira", s: 'CO-LAG' },
  { c: '13074', m: "Barranco de Loba", d: "Bolívar", s: 'CO-BOL' },
  { c: '94343', m: "Barrancominas", d: "Guainía", s: 'CO-GUA' },
  { c: '08001', m: "Barranquilla", d: "Atlántico", s: 'CO-ATL' },
  { c: '20045', m: "Becerril", d: "Cesar", s: 'CO-CES' },
  { c: '17088', m: "Belalcázar", d: "Caldas", s: 'CO-CAL' },
  { c: '15087', m: "Belén", d: "Boyacá", s: 'CO-BOY' },
  { c: '52083', m: "Belén", d: "Nariño", s: 'CO-NAR' },
  { c: '18094', m: "Belén de los Andaquíes", d: "Caquetá", s: 'CO-CAQ' },
  { c: '66088', m: "Belén de Umbría", d: "Risaralda", s: 'CO-RIS' },
  { c: '05088', m: "Bello", d: "Antioquia", s: 'CO-ANT' },
  { c: '05086', m: "Belmira", d: "Antioquia", s: 'CO-ANT' },
  { c: '25086', m: "Beltrán", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15090', m: "Berbeo", d: "Boyacá", s: 'CO-BOY' },
  { c: '05091', m: "Betania", d: "Antioquia", s: 'CO-ANT' },
  { c: '15092', m: "Betéitiva", d: "Boyacá", s: 'CO-BOY' },
  { c: '05093', m: "Betulia", d: "Antioquia", s: 'CO-ANT' },
  { c: '68092', m: "Betulia", d: "Santander", s: 'CO-SAN' },
  { c: '25095', m: "Bituima", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15097', m: "Boavita", d: "Boyacá", s: 'CO-BOY' },
  { c: '54099', m: "Bochalema", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '11001', m: "Bogotá, D.C.", d: "Bogotá, D.C.", s: 'CO-DC' },
  { c: '25099', m: "Bojacá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '27099', m: "Bojayá", d: "Chocó", s: 'CO-CHO' },
  { c: '19100', m: "Bolívar", d: "Cauca", s: 'CO-CAU' },
  { c: '68101', m: "Bolívar", d: "Santander", s: 'CO-SAN' },
  { c: '76100', m: "Bolívar", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '20060', m: "Bosconia", d: "Cesar", s: 'CO-CES' },
  { c: '15104', m: "Boyacá", d: "Boyacá", s: 'CO-BOY' },
  { c: '05107', m: "Briceño", d: "Antioquia", s: 'CO-ANT' },
  { c: '15106', m: "Briceño", d: "Boyacá", s: 'CO-BOY' },
  { c: '68001', m: "Bucaramanga", d: "Santander", s: 'CO-SAN' },
  { c: '54109', m: "Bucarasica", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '76109', m: "Buenaventura", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '15109', m: "Buenavista", d: "Boyacá", s: 'CO-BOY' },
  { c: '23079', m: "Buenavista", d: "Córdoba", s: 'CO-COR' },
  { c: '63111', m: "Buenavista", d: "Quindío", s: 'CO-QUI' },
  { c: '70110', m: "Buenavista", d: "Sucre", s: 'CO-SUC' },
  { c: '19110', m: "Buenos Aires", d: "Cauca", s: 'CO-CAU' },
  { c: '52110', m: "Buesaco", d: "Nariño", s: 'CO-NAR' },
  { c: '76113', m: "Bugalagrande", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '05113', m: "Buriticá", d: "Antioquia", s: 'CO-ANT' },
  { c: '15114', m: "Busbanzá", d: "Boyacá", s: 'CO-BOY' },
  { c: '25120', m: "Cabrera", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '68121', m: "Cabrera", d: "Santander", s: 'CO-SAN' },
  { c: '50124', m: "Cabuyaro", d: "Meta", s: 'CO-MET' },
  { c: '94886', m: "Cacahual", d: "Guainía", s: 'CO-GUA' },
  { c: '05120', m: "Cáceres", d: "Antioquia", s: 'CO-ANT' },
  { c: '25123', m: "Cachipay", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '54128', m: "Cáchira", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '54125', m: "Cácota", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05125', m: "Caicedo", d: "Antioquia", s: 'CO-ANT' },
  { c: '76122', m: "Caicedonia", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '70124', m: "Caimito", d: "Sucre", s: 'CO-SUC' },
  { c: '73124', m: "Cajamarca", d: "Tolima", s: 'CO-TOL' },
  { c: '19130', m: "Cajibío", d: "Cauca", s: 'CO-CAU' },
  { c: '25126', m: "Cajicá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '13140', m: "Calamar", d: "Bolívar", s: 'CO-BOL' },
  { c: '95015', m: "Calamar", d: "Guaviare", s: 'CO-GUV' },
  { c: '63130', m: "Calarcá", d: "Quindío", s: 'CO-QUI' },
  { c: '05129', m: "Caldas", d: "Antioquia", s: 'CO-ANT' },
  { c: '15131', m: "Caldas", d: "Boyacá", s: 'CO-BOY' },
  { c: '19137', m: "Caldono", d: "Cauca", s: 'CO-CAU' },
  { c: '68132', m: "California", d: "Santander", s: 'CO-SAN' },
  { c: '76126', m: "Calima", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '19142', m: "Caloto", d: "Cauca", s: 'CO-CAU' },
  { c: '05134', m: "Campamento", d: "Antioquia", s: 'CO-ANT' },
  { c: '08137', m: "Campo de la Cruz", d: "Atlántico", s: 'CO-ATL' },
  { c: '41132', m: "Campoalegre", d: "Huila", s: 'CO-HUI' },
  { c: '15135', m: "Campohermoso", d: "Boyacá", s: 'CO-BOY' },
  { c: '23090', m: "Canalete", d: "Córdoba", s: 'CO-COR' },
  { c: '08141', m: "Candelaria", d: "Atlántico", s: 'CO-ATL' },
  { c: '76130', m: "Candelaria", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '13160', m: "Cantagallo", d: "Bolívar", s: 'CO-BOL' },
  { c: '05138', m: "Cañasgordas", d: "Antioquia", s: 'CO-ANT' },
  { c: '25148', m: "Caparrapí", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '68147', m: "Capitanejo", d: "Santander", s: 'CO-SAN' },
  { c: '25151', m: "Cáqueza", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '05142', m: "Caracolí", d: "Antioquia", s: 'CO-ANT' },
  { c: '05145', m: "Caramanta", d: "Antioquia", s: 'CO-ANT' },
  { c: '68152', m: "Carcasí", d: "Santander", s: 'CO-SAN' },
  { c: '05147', m: "Carepa", d: "Antioquia", s: 'CO-ANT' },
  { c: '73148', m: "Carmen de Apicalá", d: "Tolima", s: 'CO-TOL' },
  { c: '25154', m: "Carmen de Carupa", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '27150', m: "Carmen del Darién", d: "Chocó", s: 'CO-CHO' },
  { c: '05150', m: "Carolina", d: "Antioquia", s: 'CO-ANT' },
  { c: '13001', m: "Cartagena de Indias", d: "Bolívar", s: 'CO-BOL' },
  { c: '18150', m: "Cartagena del Chairá", d: "Caquetá", s: 'CO-CAQ' },
  { c: '76147', m: "Cartago", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '97161', m: "Carurú", d: "Vaupés", s: 'CO-VAU' },
  { c: '73152', m: "Casabianca", d: "Tolima", s: 'CO-TOL' },
  { c: '50150', m: "Castilla la Nueva", d: "Meta", s: 'CO-MET' },
  { c: '05154', m: "Caucasia", d: "Antioquia", s: 'CO-ANT' },
  { c: '68160', m: "Cepitá", d: "Santander", s: 'CO-SAN' },
  { c: '23162', m: "Cereté", d: "Córdoba", s: 'CO-COR' },
  { c: '15162', m: "Cerinza", d: "Boyacá", s: 'CO-BOY' },
  { c: '68162', m: "Cerrito", d: "Santander", s: 'CO-SAN' },
  { c: '47161', m: "Cerro de San Antonio", d: "Magdalena", s: 'CO-MAG' },
  { c: '27160', m: "Cértegui", d: "Chocó", s: 'CO-CHO' },
  { c: '52240', m: "Chachagüí", d: "Nariño", s: 'CO-NAR' },
  { c: '25168', m: "Chaguaní", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '70230', m: "Chalán", d: "Sucre", s: 'CO-SUC' },
  { c: '85015', m: "Chámeza", d: "Casanare", s: 'CO-CAS' },
  { c: '73168', m: "Chaparral", d: "Tolima", s: 'CO-TOL' },
  { c: '68167', m: "Charalá", d: "Santander", s: 'CO-SAN' },
  { c: '68169', m: "Charta", d: "Santander", s: 'CO-SAN' },
  { c: '25175', m: "Chía", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '05172', m: "Chigorodó", d: "Antioquia", s: 'CO-ANT' },
  { c: '68176', m: "Chima", d: "Santander", s: 'CO-SAN' },
  { c: '23168', m: "Chimá", d: "Córdoba", s: 'CO-COR' },
  { c: '20175', m: "Chimichagua", d: "Cesar", s: 'CO-CES' },
  { c: '54172', m: "Chinácota", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '15172', m: "Chinavita", d: "Boyacá", s: 'CO-BOY' },
  { c: '17174', m: "Chinchiná", d: "Caldas", s: 'CO-CAL' },
  { c: '23182', m: "Chinú", d: "Córdoba", s: 'CO-COR' },
  { c: '25178', m: "Chipaque", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '68179', m: "Chipatá", d: "Santander", s: 'CO-SAN' },
  { c: '15176', m: "Chiquinquirá", d: "Boyacá", s: 'CO-BOY' },
  { c: '15232', m: "Chíquiza", d: "Boyacá", s: 'CO-BOY' },
  { c: '20178', m: "Chiriguaná", d: "Cesar", s: 'CO-CES' },
  { c: '15180', m: "Chiscas", d: "Boyacá", s: 'CO-BOY' },
  { c: '15183', m: "Chita", d: "Boyacá", s: 'CO-BOY' },
  { c: '54174', m: "Chitagá", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '15185', m: "Chitaraque", d: "Boyacá", s: 'CO-BOY' },
  { c: '15187', m: "Chivatá", d: "Boyacá", s: 'CO-BOY' },
  { c: '47170', m: "Chivolo", d: "Magdalena", s: 'CO-MAG' },
  { c: '15236', m: "Chivor", d: "Boyacá", s: 'CO-BOY' },
  { c: '25181', m: "Choachí", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25183', m: "Chocontá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '13188', m: "Cicuco", d: "Bolívar", s: 'CO-BOL' },
  { c: '47189', m: "Ciénaga", d: "Magdalena", s: 'CO-MAG' },
  { c: '23189', m: "Ciénaga de Oro", d: "Córdoba", s: 'CO-COR' },
  { c: '15189', m: "Ciénega", d: "Boyacá", s: 'CO-BOY' },
  { c: '68190', m: "Cimitarra", d: "Santander", s: 'CO-SAN' },
  { c: '63190', m: "Circasia", d: "Quindío", s: 'CO-QUI' },
  { c: '05190', m: "Cisneros", d: "Antioquia", s: 'CO-ANT' },
  { c: '05101', m: "Ciudad Bolívar", d: "Antioquia", s: 'CO-ANT' },
  { c: '13222', m: "Clemencia", d: "Bolívar", s: 'CO-BOL' },
  { c: '05197', m: "Cocorná", d: "Antioquia", s: 'CO-ANT' },
  { c: '73200', m: "Coello", d: "Tolima", s: 'CO-TOL' },
  { c: '25200', m: "Cogua", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '41206', m: "Colombia", d: "Huila", s: 'CO-HUI' },
  { c: '52203', m: "Colón", d: "Nariño", s: 'CO-NAR' },
  { c: '86219', m: "Colón", d: "Putumayo", s: 'CO-PUT' },
  { c: '70204', m: "Colosó", d: "Sucre", s: 'CO-SUC' },
  { c: '15204', m: "Cómbita", d: "Boyacá", s: 'CO-BOY' },
  { c: '05206', m: "Concepción", d: "Antioquia", s: 'CO-ANT' },
  { c: '68207', m: "Concepción", d: "Santander", s: 'CO-SAN' },
  { c: '05209', m: "Concordia", d: "Antioquia", s: 'CO-ANT' },
  { c: '47205', m: "Concordia", d: "Magdalena", s: 'CO-MAG' },
  { c: '27205', m: "Condoto", d: "Chocó", s: 'CO-CHO' },
  { c: '68209', m: "Confines", d: "Santander", s: 'CO-SAN' },
  { c: '52207', m: "Consacá", d: "Nariño", s: 'CO-NAR' },
  { c: '52210', m: "Contadero", d: "Nariño", s: 'CO-NAR' },
  { c: '68211', m: "Contratación", d: "Santander", s: 'CO-SAN' },
  { c: '54206', m: "Convención", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05212', m: "Copacabana", d: "Antioquia", s: 'CO-ANT' },
  { c: '15212', m: "Coper", d: "Boyacá", s: 'CO-BOY' },
  { c: '13212', m: "Córdoba", d: "Bolívar", s: 'CO-BOL' },
  { c: '52215', m: "Córdoba", d: "Nariño", s: 'CO-NAR' },
  { c: '63212', m: "Córdoba", d: "Quindío", s: 'CO-QUI' },
  { c: '19212', m: "Corinto", d: "Cauca", s: 'CO-CAU' },
  { c: '68217', m: "Coromoro", d: "Santander", s: 'CO-SAN' },
  { c: '70215', m: "Corozal", d: "Sucre", s: 'CO-SUC' },
  { c: '15215', m: "Corrales", d: "Boyacá", s: 'CO-BOY' },
  { c: '25214', m: "Cota", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '23300', m: "Cotorra", d: "Córdoba", s: 'CO-COR' },
  { c: '15218', m: "Covarachía", d: "Boyacá", s: 'CO-BOY' },
  { c: '70221', m: "Coveñas", d: "Sucre", s: 'CO-SUC' },
  { c: '73217', m: "Coyaima", d: "Tolima", s: 'CO-TOL' },
  { c: '81220', m: "Cravo Norte", d: "Arauca", s: 'CO-ARA' },
  { c: '52224', m: "Cuaspud Carlosama", d: "Nariño", s: 'CO-NAR' },
  { c: '15223', m: "Cubará", d: "Boyacá", s: 'CO-BOY' },
  { c: '50223', m: "Cubarral", d: "Meta", s: 'CO-MET' },
  { c: '15224', m: "Cucaita", d: "Boyacá", s: 'CO-BOY' },
  { c: '25224', m: "Cucunubá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '54223', m: "Cucutilla", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '15226', m: "Cuítiva", d: "Boyacá", s: 'CO-BOY' },
  { c: '50226', m: "Cumaral", d: "Meta", s: 'CO-MET' },
  { c: '99773', m: "Cumaribo", d: "Vichada", s: 'CO-VID' },
  { c: '52227', m: "Cumbal", d: "Nariño", s: 'CO-NAR' },
  { c: '52233', m: "Cumbitara", d: "Nariño", s: 'CO-NAR' },
  { c: '73226', m: "Cunday", d: "Tolima", s: 'CO-TOL' },
  { c: '18205', m: "Curillo", d: "Caquetá", s: 'CO-CAQ' },
  { c: '68229', m: "Curití", d: "Santander", s: 'CO-SAN' },
  { c: '20228', m: "Curumaní", d: "Cesar", s: 'CO-CES' },
  { c: '05234', m: "Dabeiba", d: "Antioquia", s: 'CO-ANT' },
  { c: '76233', m: "Dagua", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '44090', m: "Dibulla", d: "La Guajira", s: 'CO-LAG' },
  { c: '44098', m: "Distracción", d: "La Guajira", s: 'CO-LAG' },
  { c: '73236', m: "Dolores", d: "Tolima", s: 'CO-TOL' },
  { c: '05237', m: "Donmatías", d: "Antioquia", s: 'CO-ANT' },
  { c: '66170', m: "Dosquebradas", d: "Risaralda", s: 'CO-RIS' },
  { c: '15238', m: "Duitama", d: "Boyacá", s: 'CO-BOY' },
  { c: '54239', m: "Durania", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05240', m: "Ebéjico", d: "Antioquia", s: 'CO-ANT' },
  { c: '76243', m: "El Águila", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '05250', m: "El Bagre", d: "Antioquia", s: 'CO-ANT' },
  { c: '47245', m: "El Banco", d: "Magdalena", s: 'CO-MAG' },
  { c: '76246', m: "El Cairo", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '50245', m: "El Calvario", d: "Meta", s: 'CO-MET' },
  { c: '27135', m: "El Cantón del San Pablo", d: "Chocó", s: 'CO-CHO' },
  { c: '54245', m: "El Carmen", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '27245', m: "El Carmen de Atrato", d: "Chocó", s: 'CO-CHO' },
  { c: '13244', m: "El Carmen de Bolívar", d: "Bolívar", s: 'CO-BOL' },
  { c: '68235', m: "El Carmen de Chucurí", d: "Santander", s: 'CO-SAN' },
  { c: '05148', m: "El Carmen de Viboral", d: "Antioquia", s: 'CO-ANT' },
  { c: '50251', m: "El Castillo", d: "Meta", s: 'CO-MET' },
  { c: '76248', m: "El Cerrito", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '52250', m: "El Charco", d: "Nariño", s: 'CO-NAR' },
  { c: '15244', m: "El Cocuy", d: "Boyacá", s: 'CO-BOY' },
  { c: '25245', m: "El Colegio", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '20238', m: "El Copey", d: "Cesar", s: 'CO-CES' },
  { c: '18247', m: "El Doncello", d: "Caquetá", s: 'CO-CAQ' },
  { c: '50270', m: "El Dorado", d: "Meta", s: 'CO-MET' },
  { c: '76250', m: "El Dovio", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '91263', m: "El Encanto", d: "Amazonas", s: 'CO-AMA' },
  { c: '15248', m: "El Espino", d: "Boyacá", s: 'CO-BOY' },
  { c: '68245', m: "El Guacamayo", d: "Santander", s: 'CO-SAN' },
  { c: '13248', m: "El Guamo", d: "Bolívar", s: 'CO-BOL' },
  { c: '27250', m: "El Litoral del San Juan", d: "Chocó", s: 'CO-CHO' },
  { c: '44110', m: "El Molino", d: "La Guajira", s: 'CO-LAG' },
  { c: '20250', m: "El Paso", d: "Cesar", s: 'CO-CES' },
  { c: '18256', m: "El Paujíl", d: "Caquetá", s: 'CO-CAQ' },
  { c: '52254', m: "El Peñol", d: "Nariño", s: 'CO-NAR' },
  { c: '13268', m: "El Peñón", d: "Bolívar", s: 'CO-BOL' },
  { c: '25258', m: "El Peñón", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '68250', m: "El Peñón", d: "Santander", s: 'CO-SAN' },
  { c: '47258', m: "El Piñón", d: "Magdalena", s: 'CO-MAG' },
  { c: '68255', m: "El Playón", d: "Santander", s: 'CO-SAN' },
  { c: '47268', m: "El Retén", d: "Magdalena", s: 'CO-MAG' },
  { c: '95025', m: "El Retorno", d: "Guaviare", s: 'CO-GUV' },
  { c: '70233', m: "El Roble", d: "Sucre", s: 'CO-SUC' },
  { c: '25260', m: "El Rosal", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52256', m: "El Rosario", d: "Nariño", s: 'CO-NAR' },
  { c: '05697', m: "El Santuario", d: "Antioquia", s: 'CO-ANT' },
  { c: '52258', m: "El Tablón de Gómez", d: "Nariño", s: 'CO-NAR' },
  { c: '19256', m: "El Tambo", d: "Cauca", s: 'CO-CAU' },
  { c: '52260', m: "El Tambo", d: "Nariño", s: 'CO-NAR' },
  { c: '54250', m: "El Tarra", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '54261', m: "El Zulia", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '41244', m: "Elías", d: "Huila", s: 'CO-HUI' },
  { c: '68264', m: "Encino", d: "Santander", s: 'CO-SAN' },
  { c: '68266', m: "Enciso", d: "Santander", s: 'CO-SAN' },
  { c: '05264', m: "Entrerríos", d: "Antioquia", s: 'CO-ANT' },
  { c: '05266', m: "Envigado", d: "Antioquia", s: 'CO-ANT' },
  { c: '73268', m: "Espinal", d: "Tolima", s: 'CO-TOL' },
  { c: '25269', m: "Facatativá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '73270', m: "Falan", d: "Tolima", s: 'CO-TOL' },
  { c: '17272', m: "Filadelfia", d: "Caldas", s: 'CO-CAL' },
  { c: '63272', m: "Filandia", d: "Quindío", s: 'CO-QUI' },
  { c: '15272', m: "Firavitoba", d: "Boyacá", s: 'CO-BOY' },
  { c: '73275', m: "Flandes", d: "Tolima", s: 'CO-TOL' },
  { c: '18001', m: "Florencia", d: "Caquetá", s: 'CO-CAQ' },
  { c: '19290', m: "Florencia", d: "Cauca", s: 'CO-CAU' },
  { c: '15276', m: "Floresta", d: "Boyacá", s: 'CO-BOY' },
  { c: '68271', m: "Florián", d: "Santander", s: 'CO-SAN' },
  { c: '76275', m: "Florida", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '68276', m: "Floridablanca", d: "Santander", s: 'CO-SAN' },
  { c: '25279', m: "Fómeque", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '44279', m: "Fonseca", d: "La Guajira", s: 'CO-LAG' },
  { c: '81300', m: "Fortul", d: "Arauca", s: 'CO-ARA' },
  { c: '25281', m: "Fosca", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52520', m: "Francisco Pizarro", d: "Nariño", s: 'CO-NAR' },
  { c: '05282', m: "Fredonia", d: "Antioquia", s: 'CO-ANT' },
  { c: '73283', m: "Fresno", d: "Tolima", s: 'CO-TOL' },
  { c: '05284', m: "Frontino", d: "Antioquia", s: 'CO-ANT' },
  { c: '50287', m: "Fuente de Oro", d: "Meta", s: 'CO-MET' },
  { c: '47288', m: "Fundación", d: "Magdalena", s: 'CO-MAG' },
  { c: '52287', m: "Funes", d: "Nariño", s: 'CO-NAR' },
  { c: '25286', m: "Funza", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25288', m: "Fúquene", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25290', m: "Fusagasugá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25293', m: "Gachalá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25295', m: "Gachancipá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15293', m: "Gachantivá", d: "Boyacá", s: 'CO-BOY' },
  { c: '25297', m: "Gachetá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '68296', m: "Galán", d: "Santander", s: 'CO-SAN' },
  { c: '08296', m: "Galapa", d: "Atlántico", s: 'CO-ATL' },
  { c: '70235', m: "Galeras", d: "Sucre", s: 'CO-SUC' },
  { c: '25299', m: "Gama", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '20295', m: "Gamarra", d: "Cesar", s: 'CO-CES' },
  { c: '68298', m: "Gámbita", d: "Santander", s: 'CO-SAN' },
  { c: '15296', m: "Gámeza", d: "Boyacá", s: 'CO-BOY' },
  { c: '15299', m: "Garagoa", d: "Boyacá", s: 'CO-BOY' },
  { c: '41298', m: "Garzón", d: "Huila", s: 'CO-HUI' },
  { c: '63302', m: "Génova", d: "Quindío", s: 'CO-QUI' },
  { c: '41306', m: "Gigante", d: "Huila", s: 'CO-HUI' },
  { c: '76306', m: "Ginebra", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '05306', m: "Giraldo", d: "Antioquia", s: 'CO-ANT' },
  { c: '25307', m: "Girardot", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '05308', m: "Girardota", d: "Antioquia", s: 'CO-ANT' },
  { c: '68307', m: "Girón", d: "Santander", s: 'CO-SAN' },
  { c: '05310', m: "Gómez Plata", d: "Antioquia", s: 'CO-ANT' },
  { c: '20310', m: "González", d: "Cesar", s: 'CO-CES' },
  { c: '54313', m: "Gramalote", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05313', m: "Granada", d: "Antioquia", s: 'CO-ANT' },
  { c: '25312', m: "Granada", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '50313', m: "Granada", d: "Meta", s: 'CO-MET' },
  { c: '68318', m: "Guaca", d: "Santander", s: 'CO-SAN' },
  { c: '15317', m: "Guacamayas", d: "Boyacá", s: 'CO-BOY' },
  { c: '76318', m: "Guacarí", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '19300', m: "Guachené", d: "Cauca", s: 'CO-CAU' },
  { c: '25317', m: "Guachetá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52317', m: "Guachucal", d: "Nariño", s: 'CO-NAR' },
  { c: '76111', m: "Guadalajara de Buga", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '05315', m: "Guadalupe", d: "Antioquia", s: 'CO-ANT' },
  { c: '41319', m: "Guadalupe", d: "Huila", s: 'CO-HUI' },
  { c: '68320', m: "Guadalupe", d: "Santander", s: 'CO-SAN' },
  { c: '25320', m: "Guaduas", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52320', m: "Guaitarilla", d: "Nariño", s: 'CO-NAR' },
  { c: '52323', m: "Gualmatán", d: "Nariño", s: 'CO-NAR' },
  { c: '47318', m: "Guamal", d: "Magdalena", s: 'CO-MAG' },
  { c: '50318', m: "Guamal", d: "Meta", s: 'CO-MET' },
  { c: '73319', m: "Guamo", d: "Tolima", s: 'CO-TOL' },
  { c: '19318', m: "Guapi", d: "Cauca", s: 'CO-CAU' },
  { c: '68322', m: "Guapotá", d: "Santander", s: 'CO-SAN' },
  { c: '70265', m: "Guaranda", d: "Sucre", s: 'CO-SUC' },
  { c: '05318', m: "Guarne", d: "Antioquia", s: 'CO-ANT' },
  { c: '25322', m: "Guasca", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '05321', m: "Guatapé", d: "Antioquia", s: 'CO-ANT' },
  { c: '25324', m: "Guataquí", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25326', m: "Guatavita", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15322', m: "Guateque", d: "Boyacá", s: 'CO-BOY' },
  { c: '66318', m: "Guática", d: "Risaralda", s: 'CO-RIS' },
  { c: '68324', m: "Guavatá", d: "Santander", s: 'CO-SAN' },
  { c: '25328', m: "Guayabal de Síquima", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25335', m: "Guayabetal", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15325', m: "Guayatá", d: "Boyacá", s: 'CO-BOY' },
  { c: '68327', m: "Güepsa", d: "Santander", s: 'CO-SAN' },
  { c: '15332', m: "Güicán de la Sierra", d: "Boyacá", s: 'CO-BOY' },
  { c: '25339', m: "Gutiérrez", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '54344', m: "Hacarí", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '13300', m: "Hatillo de Loba", d: "Bolívar", s: 'CO-BOL' },
  { c: '68344', m: "Hato", d: "Santander", s: 'CO-SAN' },
  { c: '85125', m: "Hato Corozal", d: "Casanare", s: 'CO-CAS' },
  { c: '44378', m: "Hatonuevo", d: "La Guajira", s: 'CO-LAG' },
  { c: '05347', m: "Heliconia", d: "Antioquia", s: 'CO-ANT' },
  { c: '54347', m: "Herrán", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '73347', m: "Herveo", d: "Tolima", s: 'CO-TOL' },
  { c: '05353', m: "Hispania", d: "Antioquia", s: 'CO-ANT' },
  { c: '41349', m: "Hobo", d: "Huila", s: 'CO-HUI' },
  { c: '73349', m: "Honda", d: "Tolima", s: 'CO-TOL' },
  { c: '73001', m: "Ibagué", d: "Tolima", s: 'CO-TOL' },
  { c: '73352', m: "Icononzo", d: "Tolima", s: 'CO-TOL' },
  { c: '52352', m: "Iles", d: "Nariño", s: 'CO-NAR' },
  { c: '52354', m: "Imués", d: "Nariño", s: 'CO-NAR' },
  { c: '94001', m: "Inírida", d: "Guainía", s: 'CO-GUA' },
  { c: '19355', m: "Inzá", d: "Cauca", s: 'CO-CAU' },
  { c: '52356', m: "Ipiales", d: "Nariño", s: 'CO-NAR' },
  { c: '41357', m: "Íquira", d: "Huila", s: 'CO-HUI' },
  { c: '41359', m: "Isnos", d: "Huila", s: 'CO-HUI' },
  { c: '27361', m: "Istmina", d: "Chocó", s: 'CO-CHO' },
  { c: '05360', m: "Itagüí", d: "Antioquia", s: 'CO-ANT' },
  { c: '05361', m: "Ituango", d: "Antioquia", s: 'CO-ANT' },
  { c: '15362', m: "Iza", d: "Boyacá", s: 'CO-BOY' },
  { c: '19364', m: "Jambaló", d: "Cauca", s: 'CO-CAU' },
  { c: '76364', m: "Jamundí", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '05364', m: "Jardín", d: "Antioquia", s: 'CO-ANT' },
  { c: '15367', m: "Jenesano", d: "Boyacá", s: 'CO-BOY' },
  { c: '05368', m: "Jericó", d: "Antioquia", s: 'CO-ANT' },
  { c: '15368', m: "Jericó", d: "Boyacá", s: 'CO-BOY' },
  { c: '25368', m: "Jerusalén", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '68368', m: "Jesús María", d: "Santander", s: 'CO-SAN' },
  { c: '68370', m: "Jordán", d: "Santander", s: 'CO-SAN' },
  { c: '08372', m: "Juan de Acosta", d: "Atlántico", s: 'CO-ATL' },
  { c: '25372', m: "Junín", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '27372', m: "Juradó", d: "Chocó", s: 'CO-CHO' },
  { c: '23350', m: "La Apartada", d: "Córdoba", s: 'CO-COR' },
  { c: '41378', m: "La Argentina", d: "Huila", s: 'CO-HUI' },
  { c: '68377', m: "La Belleza", d: "Santander", s: 'CO-SAN' },
  { c: '25377', m: "La Calera", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15380', m: "La Capilla", d: "Boyacá", s: 'CO-BOY' },
  { c: '05376', m: "La Ceja", d: "Antioquia", s: 'CO-ANT' },
  { c: '66383', m: "La Celia", d: "Risaralda", s: 'CO-RIS' },
  { c: '91405', m: "La Chorrera", d: "Amazonas", s: 'CO-AMA' },
  { c: '52378', m: "La Cruz", d: "Nariño", s: 'CO-NAR' },
  { c: '76377', m: "La Cumbre", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '17380', m: "La Dorada", d: "Caldas", s: 'CO-CAL' },
  { c: '54385', m: "La Esperanza", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05380', m: "La Estrella", d: "Antioquia", s: 'CO-ANT' },
  { c: '52381', m: "La Florida", d: "Nariño", s: 'CO-NAR' },
  { c: '20383', m: "La Gloria", d: "Cesar", s: 'CO-CES' },
  { c: '94885', m: "La Guadalupe", d: "Guainía", s: 'CO-GUA' },
  { c: '20400', m: "La Jagua de Ibirico", d: "Cesar", s: 'CO-CES' },
  { c: '44420', m: "La Jagua del Pilar", d: "La Guajira", s: 'CO-LAG' },
  { c: '52385', m: "La Llanada", d: "Nariño", s: 'CO-NAR' },
  { c: '50350', m: "La Macarena", d: "Meta", s: 'CO-MET' },
  { c: '17388', m: "La Merced", d: "Caldas", s: 'CO-CAL' },
  { c: '25386', m: "La Mesa", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '18410', m: "La Montañita", d: "Caquetá", s: 'CO-CAQ' },
  { c: '25394', m: "La Palma", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '20621', m: "La Paz", d: "Cesar", s: 'CO-CES' },
  { c: '68397', m: "La Paz", d: "Santander", s: 'CO-SAN' },
  { c: '91407', m: "La Pedrera", d: "Amazonas", s: 'CO-AMA' },
  { c: '25398', m: "La Peña", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '05390', m: "La Pintada", d: "Antioquia", s: 'CO-ANT' },
  { c: '41396', m: "La Plata", d: "Huila", s: 'CO-HUI' },
  { c: '54398', m: "La Playa", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '99524', m: "La Primavera", d: "Vichada", s: 'CO-VID' },
  { c: '85136', m: "La Salina", d: "Casanare", s: 'CO-CAS' },
  { c: '19392', m: "La Sierra", d: "Cauca", s: 'CO-CAU' },
  { c: '63401', m: "La Tebaida", d: "Quindío", s: 'CO-QUI' },
  { c: '52390', m: "La Tola", d: "Nariño", s: 'CO-NAR' },
  { c: '05400', m: "La Unión", d: "Antioquia", s: 'CO-ANT' },
  { c: '52399', m: "La Unión", d: "Nariño", s: 'CO-NAR' },
  { c: '70400', m: "La Unión", d: "Sucre", s: 'CO-SUC' },
  { c: '76400', m: "La Unión", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '15403', m: "La Uvita", d: "Boyacá", s: 'CO-BOY' },
  { c: '19397', m: "La Vega", d: "Cauca", s: 'CO-CAU' },
  { c: '25402', m: "La Vega", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '91430', m: "La Victoria", d: "Amazonas", s: 'CO-AMA' },
  { c: '15401', m: "La Victoria", d: "Boyacá", s: 'CO-BOY' },
  { c: '76403', m: "La Victoria", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '66400', m: "La Virginia", d: "Risaralda", s: 'CO-RIS' },
  { c: '54377', m: "Labateca", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '15377', m: "Labranzagrande", d: "Boyacá", s: 'CO-BOY' },
  { c: '68385', m: "Landázuri", d: "Santander", s: 'CO-SAN' },
  { c: '68406', m: "Lebrija", d: "Santander", s: 'CO-SAN' },
  { c: '52405', m: "Leiva", d: "Nariño", s: 'CO-NAR' },
  { c: '50400', m: "Lejanías", d: "Meta", s: 'CO-MET' },
  { c: '25407', m: "Lenguazaque", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '73408', m: "Lérida", d: "Tolima", s: 'CO-TOL' },
  { c: '91001', m: "Leticia", d: "Amazonas", s: 'CO-AMA' },
  { c: '73411', m: "Líbano", d: "Tolima", s: 'CO-TOL' },
  { c: '05411', m: "Liborina", d: "Antioquia", s: 'CO-ANT' },
  { c: '52411', m: "Linares", d: "Nariño", s: 'CO-NAR' },
  { c: '27413', m: "Lloró", d: "Chocó", s: 'CO-CHO' },
  { c: '19418', m: "López de Micay", d: "Cauca", s: 'CO-CAU' },
  { c: '23417', m: "Lorica", d: "Córdoba", s: 'CO-COR' },
  { c: '52418', m: "Los Andes", d: "Nariño", s: 'CO-NAR' },
  { c: '23419', m: "Los Córdobas", d: "Córdoba", s: 'CO-COR' },
  { c: '70418', m: "Los Palmitos", d: "Sucre", s: 'CO-SUC' },
  { c: '54405', m: "Los Patios", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '68418', m: "Los Santos", d: "Santander", s: 'CO-SAN' },
  { c: '54418', m: "Lourdes", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '08421', m: "Luruaco", d: "Atlántico", s: 'CO-ATL' },
  { c: '15425', m: "Macanal", d: "Boyacá", s: 'CO-BOY' },
  { c: '68425', m: "Macaravita", d: "Santander", s: 'CO-SAN' },
  { c: '05425', m: "Maceo", d: "Antioquia", s: 'CO-ANT' },
  { c: '25426', m: "Machetá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25430', m: "Madrid", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '13430', m: "Magangué", d: "Bolívar", s: 'CO-BOL' },
  { c: '52427', m: "Magüí", d: "Nariño", s: 'CO-NAR' },
  { c: '13433', m: "Mahates", d: "Bolívar", s: 'CO-BOL' },
  { c: '44430', m: "Maicao", d: "La Guajira", s: 'CO-LAG' },
  { c: '70429', m: "Majagual", d: "Sucre", s: 'CO-SUC' },
  { c: '68432', m: "Málaga", d: "Santander", s: 'CO-SAN' },
  { c: '08433', m: "Malambo", d: "Atlántico", s: 'CO-ATL' },
  { c: '52435', m: "Mallama", d: "Nariño", s: 'CO-NAR' },
  { c: '08436', m: "Manatí", d: "Atlántico", s: 'CO-ATL' },
  { c: '44560', m: "Manaure", d: "La Guajira", s: 'CO-LAG' },
  { c: '20443', m: "Manaure Balcón del Cesar", d: "Cesar", s: 'CO-CES' },
  { c: '85139', m: "Maní", d: "Casanare", s: 'CO-CAS' },
  { c: '17001', m: "Manizales", d: "Caldas", s: 'CO-CAL' },
  { c: '25436', m: "Manta", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '17433', m: "Manzanares", d: "Caldas", s: 'CO-CAL' },
  { c: '50325', m: "Mapiripán", d: "Meta", s: 'CO-MET' },
  { c: '13440', m: "Margarita", d: "Bolívar", s: 'CO-BOL' },
  { c: '13442', m: "María la Baja", d: "Bolívar", s: 'CO-BOL' },
  { c: '05440', m: "Marinilla", d: "Antioquia", s: 'CO-ANT' },
  { c: '15442', m: "Maripí", d: "Boyacá", s: 'CO-BOY' },
  { c: '17442', m: "Marmato", d: "Caldas", s: 'CO-CAL' },
  { c: '17444', m: "Marquetalia", d: "Caldas", s: 'CO-CAL' },
  { c: '66440', m: "Marsella", d: "Risaralda", s: 'CO-RIS' },
  { c: '17446', m: "Marulanda", d: "Caldas", s: 'CO-CAL' },
  { c: '68444', m: "Matanza", d: "Santander", s: 'CO-SAN' },
  { c: '05001', m: "Medellín", d: "Antioquia", s: 'CO-ANT' },
  { c: '25438', m: "Medina", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '27425', m: "Medio Atrato", d: "Chocó", s: 'CO-CHO' },
  { c: '27430', m: "Medio Baudó", d: "Chocó", s: 'CO-CHO' },
  { c: '27450', m: "Medio San Juan", d: "Chocó", s: 'CO-CHO' },
  { c: '73449', m: "Melgar", d: "Tolima", s: 'CO-TOL' },
  { c: '19450', m: "Mercaderes", d: "Cauca", s: 'CO-CAU' },
  { c: '50330', m: "Mesetas", d: "Meta", s: 'CO-MET' },
  { c: '18460', m: "Milán", d: "Caquetá", s: 'CO-CAQ' },
  { c: '15455', m: "Miraflores", d: "Boyacá", s: 'CO-BOY' },
  { c: '95200', m: "Miraflores", d: "Guaviare", s: 'CO-GUV' },
  { c: '19455', m: "Miranda", d: "Cauca", s: 'CO-CAU' },
  { c: '91460', m: "Mirití - Paraná", d: "Amazonas", s: 'CO-AMA' },
  { c: '66456', m: "Mistrató", d: "Risaralda", s: 'CO-RIS' },
  { c: '97001', m: "Mitú", d: "Vaupés", s: 'CO-VAU' },
  { c: '86001', m: "Mocoa", d: "Putumayo", s: 'CO-PUT' },
  { c: '68464', m: "Mogotes", d: "Santander", s: 'CO-SAN' },
  { c: '68468', m: "Molagavita", d: "Santander", s: 'CO-SAN' },
  { c: '23464', m: "Momil", d: "Córdoba", s: 'CO-COR' },
  { c: '15464', m: "Mongua", d: "Boyacá", s: 'CO-BOY' },
  { c: '15466', m: "Monguí", d: "Boyacá", s: 'CO-BOY' },
  { c: '15469', m: "Moniquirá", d: "Boyacá", s: 'CO-BOY' },
  { c: '05467', m: "Montebello", d: "Antioquia", s: 'CO-ANT' },
  { c: '13458', m: "Montecristo", d: "Bolívar", s: 'CO-BOL' },
  { c: '23466', m: "Montelíbano", d: "Córdoba", s: 'CO-COR' },
  { c: '63470', m: "Montenegro", d: "Quindío", s: 'CO-QUI' },
  { c: '23001', m: "Montería", d: "Córdoba", s: 'CO-COR' },
  { c: '85162', m: "Monterrey", d: "Casanare", s: 'CO-CAS' },
  { c: '23500', m: "Moñitos", d: "Córdoba", s: 'CO-COR' },
  { c: '13473', m: "Morales", d: "Bolívar", s: 'CO-BOL' },
  { c: '19473', m: "Morales", d: "Cauca", s: 'CO-CAU' },
  { c: '18479', m: "Morelia", d: "Caquetá", s: 'CO-CAQ' },
  { c: '94888', m: "Morichal", d: "Guainía", s: 'CO-GUA' },
  { c: '70473', m: "Morroa", d: "Sucre", s: 'CO-SUC' },
  { c: '25473', m: "Mosquera", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52473', m: "Mosquera", d: "Nariño", s: 'CO-NAR' },
  { c: '15476', m: "Motavita", d: "Boyacá", s: 'CO-BOY' },
  { c: '73461', m: "Murillo", d: "Tolima", s: 'CO-TOL' },
  { c: '05475', m: "Murindó", d: "Antioquia", s: 'CO-ANT' },
  { c: '05480', m: "Mutatá", d: "Antioquia", s: 'CO-ANT' },
  { c: '54480', m: "Mutiscua", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '15480', m: "Muzo", d: "Boyacá", s: 'CO-BOY' },
  { c: '05483', m: "Nariño", d: "Antioquia", s: 'CO-ANT' },
  { c: '25483', m: "Nariño", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52480', m: "Nariño", d: "Nariño", s: 'CO-NAR' },
  { c: '41483', m: "Nátaga", d: "Huila", s: 'CO-HUI' },
  { c: '73483', m: "Natagaima", d: "Tolima", s: 'CO-TOL' },
  { c: '05495', m: "Nechí", d: "Antioquia", s: 'CO-ANT' },
  { c: '05490', m: "Necoclí", d: "Antioquia", s: 'CO-ANT' },
  { c: '17486', m: "Neira", d: "Caldas", s: 'CO-CAL' },
  { c: '41001', m: "Neiva", d: "Huila", s: 'CO-HUI' },
  { c: '25486', m: "Nemocón", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25488', m: "Nilo", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25489', m: "Nimaima", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15491', m: "Nobsa", d: "Boyacá", s: 'CO-BOY' },
  { c: '25491', m: "Nocaima", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '17495', m: "Norcasia", d: "Caldas", s: 'CO-CAL' },
  { c: '13490', m: "Norosí", d: "Bolívar", s: 'CO-BOL' },
  { c: '27491', m: "Nóvita", d: "Chocó", s: 'CO-CHO' },
  { c: '47460', m: "Nueva Granada", d: "Magdalena", s: 'CO-MAG' },
  { c: '27493', m: "Nuevo Belén de Bajirá", d: "Chocó", s: 'CO-CHO' },
  { c: '15494', m: "Nuevo Colón", d: "Boyacá", s: 'CO-BOY' },
  { c: '85225', m: "Nunchía", d: "Casanare", s: 'CO-CAS' },
  { c: '27495', m: "Nuquí", d: "Chocó", s: 'CO-CHO' },
  { c: '76497', m: "Obando", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '68498', m: "Ocamonte", d: "Santander", s: 'CO-SAN' },
  { c: '54498', m: "Ocaña", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '68500', m: "Oiba", d: "Santander", s: 'CO-SAN' },
  { c: '15500', m: "Oicatá", d: "Boyacá", s: 'CO-BOY' },
  { c: '05501', m: "Olaya", d: "Antioquia", s: 'CO-ANT' },
  { c: '52490', m: "Olaya Herrera", d: "Nariño", s: 'CO-NAR' },
  { c: '68502', m: "Onzaga", d: "Santander", s: 'CO-SAN' },
  { c: '41503', m: "Oporapa", d: "Huila", s: 'CO-HUI' },
  { c: '86320', m: "Orito", d: "Putumayo", s: 'CO-PUT' },
  { c: '85230', m: "Orocué", d: "Casanare", s: 'CO-CAS' },
  { c: '73504', m: "Ortega", d: "Tolima", s: 'CO-TOL' },
  { c: '52506', m: "Ospina", d: "Nariño", s: 'CO-NAR' },
  { c: '15507', m: "Otanche", d: "Boyacá", s: 'CO-BOY' },
  { c: '70508', m: "Ovejas", d: "Sucre", s: 'CO-SUC' },
  { c: '15511', m: "Pachavita", d: "Boyacá", s: 'CO-BOY' },
  { c: '25513', m: "Pacho", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '97511', m: "Pacoa", d: "Vaupés", s: 'CO-VAU' },
  { c: '17513', m: "Pácora", d: "Caldas", s: 'CO-CAL' },
  { c: '19513', m: "Padilla", d: "Cauca", s: 'CO-CAU' },
  { c: '15514', m: "Páez", d: "Boyacá", s: 'CO-BOY' },
  { c: '19517', m: "Páez", d: "Cauca", s: 'CO-CAU' },
  { c: '41518', m: "Paicol", d: "Huila", s: 'CO-HUI' },
  { c: '20517', m: "Pailitas", d: "Cesar", s: 'CO-CES' },
  { c: '25518', m: "Paime", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15516', m: "Paipa", d: "Boyacá", s: 'CO-BOY' },
  { c: '15518', m: "Pajarito", d: "Boyacá", s: 'CO-BOY' },
  { c: '41524', m: "Palermo", d: "Huila", s: 'CO-HUI' },
  { c: '17524', m: "Palestina", d: "Caldas", s: 'CO-CAL' },
  { c: '41530', m: "Palestina", d: "Huila", s: 'CO-HUI' },
  { c: '68522', m: "Palmar", d: "Santander", s: 'CO-SAN' },
  { c: '08520', m: "Palmar de Varela", d: "Atlántico", s: 'CO-ATL' },
  { c: '68524', m: "Palmas del Socorro", d: "Santander", s: 'CO-SAN' },
  { c: '76520', m: "Palmira", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '70523', m: "Palmito", d: "Sucre", s: 'CO-SUC' },
  { c: '73520', m: "Palocabildo", d: "Tolima", s: 'CO-TOL' },
  { c: '54518', m: "Pamplona", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '54520', m: "Pamplonita", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '94887', m: "Pana Pana", d: "Guainía", s: 'CO-GUA' },
  { c: '25524', m: "Pandi", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15522', m: "Panqueba", d: "Boyacá", s: 'CO-BOY' },
  { c: '97777', m: "Papunahua", d: "Vaupés", s: 'CO-VAU' },
  { c: '68533', m: "Páramo", d: "Santander", s: 'CO-SAN' },
  { c: '25530', m: "Paratebueno", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25535', m: "Pasca", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52001', m: "Pasto", d: "Nariño", s: 'CO-NAR' },
  { c: '19532', m: "Patía", d: "Cauca", s: 'CO-CAU' },
  { c: '15531', m: "Pauna", d: "Boyacá", s: 'CO-BOY' },
  { c: '15533', m: "Paya", d: "Boyacá", s: 'CO-BOY' },
  { c: '85250', m: "Paz de Ariporo", d: "Casanare", s: 'CO-CAS' },
  { c: '15537', m: "Paz de Río", d: "Boyacá", s: 'CO-BOY' },
  { c: '47541', m: "Pedraza", d: "Magdalena", s: 'CO-MAG' },
  { c: '20550', m: "Pelaya", d: "Cesar", s: 'CO-CES' },
  { c: '17541', m: "Pensilvania", d: "Caldas", s: 'CO-CAL' },
  { c: '05541', m: "Peñol", d: "Antioquia", s: 'CO-ANT' },
  { c: '05543', m: "Peque", d: "Antioquia", s: 'CO-ANT' },
  { c: '66001', m: "Pereira", d: "Risaralda", s: 'CO-RIS' },
  { c: '15542', m: "Pesca", d: "Boyacá", s: 'CO-BOY' },
  { c: '19533', m: "Piamonte", d: "Cauca", s: 'CO-CAU' },
  { c: '68547', m: "Piedecuesta", d: "Santander", s: 'CO-SAN' },
  { c: '73547', m: "Piedras", d: "Tolima", s: 'CO-TOL' },
  { c: '19548', m: "Piendamó - Tunía", d: "Cauca", s: 'CO-CAU' },
  { c: '63548', m: "Pijao", d: "Quindío", s: 'CO-QUI' },
  { c: '47545', m: "Pijiño del Carmen", d: "Magdalena", s: 'CO-MAG' },
  { c: '68549', m: "Pinchote", d: "Santander", s: 'CO-SAN' },
  { c: '13549', m: "Pinillos", d: "Bolívar", s: 'CO-BOL' },
  { c: '08549', m: "Piojó", d: "Atlántico", s: 'CO-ATL' },
  { c: '15550', m: "Pisba", d: "Boyacá", s: 'CO-BOY' },
  { c: '41548', m: "Pital", d: "Huila", s: 'CO-HUI' },
  { c: '41551', m: "Pitalito", d: "Huila", s: 'CO-HUI' },
  { c: '47551', m: "Pivijay", d: "Magdalena", s: 'CO-MAG' },
  { c: '73555', m: "Planadas", d: "Tolima", s: 'CO-TOL' },
  { c: '23555', m: "Planeta Rica", d: "Córdoba", s: 'CO-COR' },
  { c: '47555', m: "Plato", d: "Magdalena", s: 'CO-MAG' },
  { c: '52540', m: "Policarpa", d: "Nariño", s: 'CO-NAR' },
  { c: '08558', m: "Polonuevo", d: "Atlántico", s: 'CO-ATL' },
  { c: '08560', m: "Ponedera", d: "Atlántico", s: 'CO-ATL' },
  { c: '19001', m: "Popayán", d: "Cauca", s: 'CO-CAU' },
  { c: '85263', m: "Pore", d: "Casanare", s: 'CO-CAS' },
  { c: '52560', m: "Potosí", d: "Nariño", s: 'CO-NAR' },
  { c: '76563', m: "Pradera", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '73563', m: "Prado", d: "Tolima", s: 'CO-TOL' },
  { c: '88564', m: "Providencia", d: "Archipiélago de San Andrés, Providencia y Santa Catalina", s: 'CO-SAP' },
  { c: '52565', m: "Providencia", d: "Nariño", s: 'CO-NAR' },
  { c: '20570', m: "Pueblo Bello", d: "Cesar", s: 'CO-CES' },
  { c: '23570', m: "Pueblo Nuevo", d: "Córdoba", s: 'CO-COR' },
  { c: '66572', m: "Pueblo Rico", d: "Risaralda", s: 'CO-RIS' },
  { c: '05576', m: "Pueblorrico", d: "Antioquia", s: 'CO-ANT' },
  { c: '47570', m: "Puebloviejo", d: "Magdalena", s: 'CO-MAG' },
  { c: '68572', m: "Puente Nacional", d: "Santander", s: 'CO-SAN' },
  { c: '52573', m: "Puerres", d: "Nariño", s: 'CO-NAR' },
  { c: '91530', m: "Puerto Alegría", d: "Amazonas", s: 'CO-AMA' },
  { c: '91536', m: "Puerto Arica", d: "Amazonas", s: 'CO-AMA' },
  { c: '86568', m: "Puerto Asís", d: "Putumayo", s: 'CO-PUT' },
  { c: '05579', m: "Puerto Berrío", d: "Antioquia", s: 'CO-ANT' },
  { c: '15572', m: "Puerto Boyacá", d: "Boyacá", s: 'CO-BOY' },
  { c: '86569', m: "Puerto Caicedo", d: "Putumayo", s: 'CO-PUT' },
  { c: '99001', m: "Puerto Carreño", d: "Vichada", s: 'CO-VID' },
  { c: '08573', m: "Puerto Colombia", d: "Atlántico", s: 'CO-ATL' },
  { c: '94884', m: "Puerto Colombia", d: "Guainía", s: 'CO-GUA' },
  { c: '50450', m: "Puerto Concordia", d: "Meta", s: 'CO-MET' },
  { c: '23574', m: "Puerto Escondido", d: "Córdoba", s: 'CO-COR' },
  { c: '50568', m: "Puerto Gaitán", d: "Meta", s: 'CO-MET' },
  { c: '86571', m: "Puerto Guzmán", d: "Putumayo", s: 'CO-PUT' },
  { c: '86573', m: "Puerto Leguízamo", d: "Putumayo", s: 'CO-PUT' },
  { c: '23580', m: "Puerto Libertador", d: "Córdoba", s: 'CO-COR' },
  { c: '50577', m: "Puerto Lleras", d: "Meta", s: 'CO-MET' },
  { c: '50573', m: "Puerto López", d: "Meta", s: 'CO-MET' },
  { c: '05585', m: "Puerto Nare", d: "Antioquia", s: 'CO-ANT' },
  { c: '91540', m: "Puerto Nariño", d: "Amazonas", s: 'CO-AMA' },
  { c: '68573', m: "Puerto Parra", d: "Santander", s: 'CO-SAN' },
  { c: '18592', m: "Puerto Rico", d: "Caquetá", s: 'CO-CAQ' },
  { c: '50590', m: "Puerto Rico", d: "Meta", s: 'CO-MET' },
  { c: '81591', m: "Puerto Rondón", d: "Arauca", s: 'CO-ARA' },
  { c: '25572', m: "Puerto Salgar", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '91669', m: "Puerto Santander", d: "Amazonas", s: 'CO-AMA' },
  { c: '54553', m: "Puerto Santander", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '19573', m: "Puerto Tejada", d: "Cauca", s: 'CO-CAU' },
  { c: '05591', m: "Puerto Triunfo", d: "Antioquia", s: 'CO-ANT' },
  { c: '68575', m: "Puerto Wilches", d: "Santander", s: 'CO-SAN' },
  { c: '25580', m: "Pulí", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52585', m: "Pupiales", d: "Nariño", s: 'CO-NAR' },
  { c: '19585', m: "Puracé", d: "Cauca", s: 'CO-CAU' },
  { c: '73585', m: "Purificación", d: "Tolima", s: 'CO-TOL' },
  { c: '23586', m: "Purísima de la Concepción", d: "Córdoba", s: 'CO-COR' },
  { c: '25592', m: "Quebradanegra", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25594', m: "Quetame", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '27001', m: "Quibdó", d: "Chocó", s: 'CO-CHO' },
  { c: '63594', m: "Quimbaya", d: "Quindío", s: 'CO-QUI' },
  { c: '66594', m: "Quinchía", d: "Risaralda", s: 'CO-RIS' },
  { c: '15580', m: "Quípama", d: "Boyacá", s: 'CO-BOY' },
  { c: '25596', m: "Quipile", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '54599', m: "Ragonvalia", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '15599', m: "Ramiriquí", d: "Boyacá", s: 'CO-BOY' },
  { c: '15600', m: "Ráquira", d: "Boyacá", s: 'CO-BOY' },
  { c: '85279', m: "Recetor", d: "Casanare", s: 'CO-CAS' },
  { c: '13580', m: "Regidor", d: "Bolívar", s: 'CO-BOL' },
  { c: '05604', m: "Remedios", d: "Antioquia", s: 'CO-ANT' },
  { c: '47605', m: "Remolino", d: "Magdalena", s: 'CO-MAG' },
  { c: '08606', m: "Repelón", d: "Atlántico", s: 'CO-ATL' },
  { c: '50606', m: "Restrepo", d: "Meta", s: 'CO-MET' },
  { c: '76606', m: "Restrepo", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '05607', m: "Retiro", d: "Antioquia", s: 'CO-ANT' },
  { c: '25612', m: "Ricaurte", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52612', m: "Ricaurte", d: "Nariño", s: 'CO-NAR' },
  { c: '20614', m: "Río de Oro", d: "Cesar", s: 'CO-CES' },
  { c: '27580', m: "Río Iró", d: "Chocó", s: 'CO-CHO' },
  { c: '27600', m: "Río Quito", d: "Chocó", s: 'CO-CHO' },
  { c: '13600', m: "Río Viejo", d: "Bolívar", s: 'CO-BOL' },
  { c: '73616', m: "Rioblanco", d: "Tolima", s: 'CO-TOL' },
  { c: '76616', m: "Riofrío", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '44001', m: "Riohacha", d: "La Guajira", s: 'CO-LAG' },
  { c: '05615', m: "Rionegro", d: "Antioquia", s: 'CO-ANT' },
  { c: '68615', m: "Rionegro", d: "Santander", s: 'CO-SAN' },
  { c: '17614', m: "Riosucio", d: "Caldas", s: 'CO-CAL' },
  { c: '27615', m: "Riosucio", d: "Chocó", s: 'CO-CHO' },
  { c: '17616', m: "Risaralda", d: "Caldas", s: 'CO-CAL' },
  { c: '41615', m: "Rivera", d: "Huila", s: 'CO-HUI' },
  { c: '52621', m: "Roberto Payán", d: "Nariño", s: 'CO-NAR' },
  { c: '76622', m: "Roldanillo", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '73622', m: "Roncesvalles", d: "Tolima", s: 'CO-TOL' },
  { c: '15621', m: "Rondón", d: "Boyacá", s: 'CO-BOY' },
  { c: '19622', m: "Rosas", d: "Cauca", s: 'CO-CAU' },
  { c: '73624', m: "Rovira", d: "Tolima", s: 'CO-TOL' },
  { c: '68655', m: "Sabana de Torres", d: "Santander", s: 'CO-SAN' },
  { c: '08634', m: "Sabanagrande", d: "Atlántico", s: 'CO-ATL' },
  { c: '05628', m: "Sabanalarga", d: "Antioquia", s: 'CO-ANT' },
  { c: '08638', m: "Sabanalarga", d: "Atlántico", s: 'CO-ATL' },
  { c: '85300', m: "Sabanalarga", d: "Casanare", s: 'CO-CAS' },
  { c: '47660', m: "Sabanas de San Ángel", d: "Magdalena", s: 'CO-MAG' },
  { c: '05631', m: "Sabaneta", d: "Antioquia", s: 'CO-ANT' },
  { c: '15632', m: "Saboyá", d: "Boyacá", s: 'CO-BOY' },
  { c: '85315', m: "Sácama", d: "Casanare", s: 'CO-CAS' },
  { c: '15638', m: "Sáchica", d: "Boyacá", s: 'CO-BOY' },
  { c: '23660', m: "Sahagún", d: "Córdoba", s: 'CO-COR' },
  { c: '41660', m: "Saladoblanco", d: "Huila", s: 'CO-HUI' },
  { c: '17653', m: "Salamina", d: "Caldas", s: 'CO-CAL' },
  { c: '47675', m: "Salamina", d: "Magdalena", s: 'CO-MAG' },
  { c: '54660', m: "Salazar", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '73671', m: "Saldaña", d: "Tolima", s: 'CO-TOL' },
  { c: '63690', m: "Salento", d: "Quindío", s: 'CO-QUI' },
  { c: '05642', m: "Salgar", d: "Antioquia", s: 'CO-ANT' },
  { c: '15646', m: "Samacá", d: "Boyacá", s: 'CO-BOY' },
  { c: '17662', m: "Samaná", d: "Caldas", s: 'CO-CAL' },
  { c: '52678', m: "Samaniego", d: "Nariño", s: 'CO-NAR' },
  { c: '70670', m: "Sampués", d: "Sucre", s: 'CO-SUC' },
  { c: '41668', m: "San Agustín", d: "Huila", s: 'CO-HUI' },
  { c: '20710', m: "San Alberto", d: "Cesar", s: 'CO-CES' },
  { c: '88001', m: "San Andrés", d: "Archipiélago de San Andrés, Providencia y Santa Catalina", s: 'CO-SAP' },
  { c: '68669', m: "San Andrés", d: "Santander", s: 'CO-SAN' },
  { c: '05647', m: "San Andrés de Cuerquía", d: "Antioquia", s: 'CO-ANT' },
  { c: '23670', m: "San Andrés de Sotavento", d: "Córdoba", s: 'CO-COR' },
  { c: '52835', m: "San Andrés de Tumaco", d: "Nariño", s: 'CO-NAR' },
  { c: '23672', m: "San Antero", d: "Córdoba", s: 'CO-COR' },
  { c: '73675', m: "San Antonio", d: "Tolima", s: 'CO-TOL' },
  { c: '25645', m: "San Antonio del Tequendama", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '68673', m: "San Benito", d: "Santander", s: 'CO-SAN' },
  { c: '70678', m: "San Benito Abad", d: "Sucre", s: 'CO-SUC' },
  { c: '25649', m: "San Bernardo", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52685', m: "San Bernardo", d: "Nariño", s: 'CO-NAR' },
  { c: '23675', m: "San Bernardo del Viento", d: "Córdoba", s: 'CO-COR' },
  { c: '54670', m: "San Calixto", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05649', m: "San Carlos", d: "Antioquia", s: 'CO-ANT' },
  { c: '23678', m: "San Carlos", d: "Córdoba", s: 'CO-COR' },
  { c: '50680', m: "San Carlos de Guaroa", d: "Meta", s: 'CO-MET' },
  { c: '25653', m: "San Cayetano", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '54673', m: "San Cayetano", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '13620', m: "San Cristóbal", d: "Bolívar", s: 'CO-BOL' },
  { c: '20750', m: "San Diego", d: "Cesar", s: 'CO-CES' },
  { c: '15660', m: "San Eduardo", d: "Boyacá", s: 'CO-BOY' },
  { c: '13647', m: "San Estanislao", d: "Bolívar", s: 'CO-BOL' },
  { c: '94883', m: "San Felipe", d: "Guainía", s: 'CO-GUA' },
  { c: '13650', m: "San Fernando", d: "Bolívar", s: 'CO-BOL' },
  { c: '05652', m: "San Francisco", d: "Antioquia", s: 'CO-ANT' },
  { c: '25658', m: "San Francisco", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '86755', m: "San Francisco", d: "Putumayo", s: 'CO-PUT' },
  { c: '68679', m: "San Gil", d: "Santander", s: 'CO-SAN' },
  { c: '13654', m: "San Jacinto", d: "Bolívar", s: 'CO-BOL' },
  { c: '13655', m: "San Jacinto del Cauca", d: "Bolívar", s: 'CO-BOL' },
  { c: '05656', m: "San Jerónimo", d: "Antioquia", s: 'CO-ANT' },
  { c: '68682', m: "San Joaquín", d: "Santander", s: 'CO-SAN' },
  { c: '17665', m: "San José", d: "Caldas", s: 'CO-CAL' },
  { c: '54001', m: "San José de Cúcuta", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '05658', m: "San José de la Montaña", d: "Antioquia", s: 'CO-ANT' },
  { c: '68684', m: "San José de Miranda", d: "Santander", s: 'CO-SAN' },
  { c: '15664', m: "San José de Pare", d: "Boyacá", s: 'CO-BOY' },
  { c: '70823', m: "San José de Toluviejo", d: "Sucre", s: 'CO-SUC' },
  { c: '23682', m: "San José de Uré", d: "Córdoba", s: 'CO-COR' },
  { c: '18610', m: "San José del Fragua", d: "Caquetá", s: 'CO-CAQ' },
  { c: '95001', m: "San José del Guaviare", d: "Guaviare", s: 'CO-GUV' },
  { c: '27660', m: "San José del Palmar", d: "Chocó", s: 'CO-CHO' },
  { c: '50683', m: "San Juan de Arama", d: "Meta", s: 'CO-MET' },
  { c: '70702', m: "San Juan de Betulia", d: "Sucre", s: 'CO-SUC' },
  { c: '25662', m: "San Juan de Rioseco", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '05659', m: "San Juan de Urabá", d: "Antioquia", s: 'CO-ANT' },
  { c: '44650', m: "San Juan del Cesar", d: "La Guajira", s: 'CO-LAG' },
  { c: '13657', m: "San Juan Nepomuceno", d: "Bolívar", s: 'CO-BOL' },
  { c: '50686', m: "San Juanito", d: "Meta", s: 'CO-MET' },
  { c: '52687', m: "San Lorenzo", d: "Nariño", s: 'CO-NAR' },
  { c: '05660', m: "San Luis", d: "Antioquia", s: 'CO-ANT' },
  { c: '73678', m: "San Luis", d: "Tolima", s: 'CO-TOL' },
  { c: '15667', m: "San Luis de Gaceno", d: "Boyacá", s: 'CO-BOY' },
  { c: '85325', m: "San Luis de Palenque", d: "Casanare", s: 'CO-CAS' },
  { c: '70742', m: "San Luis de Sincé", d: "Sucre", s: 'CO-SUC' },
  { c: '70708', m: "San Marcos", d: "Sucre", s: 'CO-SUC' },
  { c: '20770', m: "San Martín", d: "Cesar", s: 'CO-CES' },
  { c: '50689', m: "San Martín", d: "Meta", s: 'CO-MET' },
  { c: '13667', m: "San Martín de Loba", d: "Bolívar", s: 'CO-BOL' },
  { c: '15673', m: "San Mateo", d: "Boyacá", s: 'CO-BOY' },
  { c: '86757', m: "San Miguel", d: "Putumayo", s: 'CO-PUT' },
  { c: '68686', m: "San Miguel", d: "Santander", s: 'CO-SAN' },
  { c: '15676', m: "San Miguel de Sema", d: "Boyacá", s: 'CO-BOY' },
  { c: '70713', m: "San Onofre", d: "Sucre", s: 'CO-SUC' },
  { c: '13670', m: "San Pablo", d: "Bolívar", s: 'CO-BOL' },
  { c: '52693', m: "San Pablo", d: "Nariño", s: 'CO-NAR' },
  { c: '15681', m: "San Pablo de Borbur", d: "Boyacá", s: 'CO-BOY' },
  { c: '70717', m: "San Pedro", d: "Sucre", s: 'CO-SUC' },
  { c: '76670', m: "San Pedro", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '52694', m: "San Pedro de Cartago", d: "Nariño", s: 'CO-NAR' },
  { c: '05664', m: "San Pedro de los Milagros", d: "Antioquia", s: 'CO-ANT' },
  { c: '05665', m: "San Pedro de Urabá", d: "Antioquia", s: 'CO-ANT' },
  { c: '23686', m: "San Pelayo", d: "Córdoba", s: 'CO-COR' },
  { c: '05667', m: "San Rafael", d: "Antioquia", s: 'CO-ANT' },
  { c: '05670', m: "San Roque", d: "Antioquia", s: 'CO-ANT' },
  { c: '19693', m: "San Sebastián", d: "Cauca", s: 'CO-CAU' },
  { c: '47692', m: "San Sebastián de Buenavista", d: "Magdalena", s: 'CO-MAG' },
  { c: '73443', m: "San Sebastián de Mariquita", d: "Tolima", s: 'CO-TOL' },
  { c: '68689', m: "San Vicente de Chucurí", d: "Santander", s: 'CO-SAN' },
  { c: '18753', m: "San Vicente del Caguán", d: "Caquetá", s: 'CO-CAQ' },
  { c: '05674', m: "San Vicente Ferrer", d: "Antioquia", s: 'CO-ANT' },
  { c: '47703', m: "San Zenón", d: "Magdalena", s: 'CO-MAG' },
  { c: '52683', m: "Sandoná", d: "Nariño", s: 'CO-NAR' },
  { c: '47707', m: "Santa Ana", d: "Magdalena", s: 'CO-MAG' },
  { c: '05679', m: "Santa Bárbara", d: "Antioquia", s: 'CO-ANT' },
  { c: '52696', m: "Santa Bárbara", d: "Nariño", s: 'CO-NAR' },
  { c: '68705', m: "Santa Bárbara", d: "Santander", s: 'CO-SAN' },
  { c: '47720', m: "Santa Bárbara de Pinto", d: "Magdalena", s: 'CO-MAG' },
  { c: '13673', m: "Santa Catalina", d: "Bolívar", s: 'CO-BOL' },
  { c: '13468', m: "Santa Cruz de Mompox", d: "Bolívar", s: 'CO-BOL' },
  { c: '05042', m: "Santa Fé de Antioquia", d: "Antioquia", s: 'CO-ANT' },
  { c: '68720', m: "Santa Helena del Opón", d: "Santander", s: 'CO-SAN' },
  { c: '73686', m: "Santa Isabel", d: "Tolima", s: 'CO-TOL' },
  { c: '08675', m: "Santa Lucía", d: "Atlántico", s: 'CO-ATL' },
  { c: '15690', m: "Santa María", d: "Boyacá", s: 'CO-BOY' },
  { c: '41676', m: "Santa María", d: "Huila", s: 'CO-HUI' },
  { c: '47001', m: "Santa Marta", d: "Magdalena", s: 'CO-MAG' },
  { c: '13683', m: "Santa Rosa", d: "Bolívar", s: 'CO-BOL' },
  { c: '19701', m: "Santa Rosa", d: "Cauca", s: 'CO-CAU' },
  { c: '66682', m: "Santa Rosa de Cabal", d: "Risaralda", s: 'CO-RIS' },
  { c: '05686', m: "Santa Rosa de Osos", d: "Antioquia", s: 'CO-ANT' },
  { c: '15693', m: "Santa Rosa de Viterbo", d: "Boyacá", s: 'CO-BOY' },
  { c: '13688', m: "Santa Rosa del Sur", d: "Bolívar", s: 'CO-BOL' },
  { c: '99624', m: "Santa Rosalía", d: "Vichada", s: 'CO-VID' },
  { c: '15696', m: "Santa Sofía", d: "Boyacá", s: 'CO-BOY' },
  { c: '52699', m: "Santacruz", d: "Nariño", s: 'CO-NAR' },
  { c: '15686', m: "Santana", d: "Boyacá", s: 'CO-BOY' },
  { c: '19698', m: "Santander de Quilichao", d: "Cauca", s: 'CO-CAU' },
  { c: '54680', m: "Santiago", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '86760', m: "Santiago", d: "Putumayo", s: 'CO-PUT' },
  { c: '76001', m: "Santiago de Cali", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '70820', m: "Santiago de Tolú", d: "Sucre", s: 'CO-SUC' },
  { c: '05690', m: "Santo Domingo", d: "Antioquia", s: 'CO-ANT' },
  { c: '08685', m: "Santo Tomás", d: "Atlántico", s: 'CO-ATL' },
  { c: '66687', m: "Santuario", d: "Risaralda", s: 'CO-RIS' },
  { c: '52720', m: "Sapuyes", d: "Nariño", s: 'CO-NAR' },
  { c: '81736', m: "Saravena", d: "Arauca", s: 'CO-ARA' },
  { c: '54720', m: "Sardinata", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '25718', m: "Sasaima", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15720', m: "Sativanorte", d: "Boyacá", s: 'CO-BOY' },
  { c: '15723', m: "Sativasur", d: "Boyacá", s: 'CO-BOY' },
  { c: '05736', m: "Segovia", d: "Antioquia", s: 'CO-ANT' },
  { c: '25736', m: "Sesquilé", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '76736', m: "Sevilla", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '15740', m: "Siachoque", d: "Boyacá", s: 'CO-BOY' },
  { c: '25740', m: "Sibaté", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '86749', m: "Sibundoy", d: "Putumayo", s: 'CO-PUT' },
  { c: '54743', m: "Silos", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '25743', m: "Silvania", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '19743', m: "Silvia", d: "Cauca", s: 'CO-CAU' },
  { c: '68745', m: "Simacota", d: "Santander", s: 'CO-SAN' },
  { c: '25745', m: "Simijaca", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '13744', m: "Simití", d: "Bolívar", s: 'CO-BOL' },
  { c: '70001', m: "Sincelejo", d: "Sucre", s: 'CO-SUC' },
  { c: '27745', m: "Sipí", d: "Chocó", s: 'CO-CHO' },
  { c: '47745', m: "Sitionuevo", d: "Magdalena", s: 'CO-MAG' },
  { c: '25754', m: "Soacha", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15753', m: "Soatá", d: "Boyacá", s: 'CO-BOY' },
  { c: '15757', m: "Socha", d: "Boyacá", s: 'CO-BOY' },
  { c: '68755', m: "Socorro", d: "Santander", s: 'CO-SAN' },
  { c: '15755', m: "Socotá", d: "Boyacá", s: 'CO-BOY' },
  { c: '15759', m: "Sogamoso", d: "Boyacá", s: 'CO-BOY' },
  { c: '18756', m: "Solano", d: "Caquetá", s: 'CO-CAQ' },
  { c: '08758', m: "Soledad", d: "Atlántico", s: 'CO-ATL' },
  { c: '18785', m: "Solita", d: "Caquetá", s: 'CO-CAQ' },
  { c: '15761', m: "Somondoco", d: "Boyacá", s: 'CO-BOY' },
  { c: '05756', m: "Sonsón", d: "Antioquia", s: 'CO-ANT' },
  { c: '05761', m: "Sopetrán", d: "Antioquia", s: 'CO-ANT' },
  { c: '13760', m: "Soplaviento", d: "Bolívar", s: 'CO-BOL' },
  { c: '25758', m: "Sopó", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15762', m: "Sora", d: "Boyacá", s: 'CO-BOY' },
  { c: '15764', m: "Soracá", d: "Boyacá", s: 'CO-BOY' },
  { c: '15763', m: "Sotaquirá", d: "Boyacá", s: 'CO-BOY' },
  { c: '19760', m: "Sotará - Paispamba", d: "Cauca", s: 'CO-CAU' },
  { c: '68770', m: "Suaita", d: "Santander", s: 'CO-SAN' },
  { c: '08770', m: "Suan", d: "Atlántico", s: 'CO-ATL' },
  { c: '19780', m: "Suárez", d: "Cauca", s: 'CO-CAU' },
  { c: '73770', m: "Suárez", d: "Tolima", s: 'CO-TOL' },
  { c: '41770', m: "Suaza", d: "Huila", s: 'CO-HUI' },
  { c: '25769', m: "Subachoque", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '19785', m: "Sucre", d: "Cauca", s: 'CO-CAU' },
  { c: '68773', m: "Sucre", d: "Santander", s: 'CO-SAN' },
  { c: '70771', m: "Sucre", d: "Sucre", s: 'CO-SUC' },
  { c: '25772', m: "Suesca", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25777', m: "Supatá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '17777', m: "Supía", d: "Caldas", s: 'CO-CAL' },
  { c: '68780', m: "Suratá", d: "Santander", s: 'CO-SAN' },
  { c: '25779', m: "Susa", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15774', m: "Susacón", d: "Boyacá", s: 'CO-BOY' },
  { c: '15776', m: "Sutamarchán", d: "Boyacá", s: 'CO-BOY' },
  { c: '25781', m: "Sutatausa", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15778', m: "Sutatenza", d: "Boyacá", s: 'CO-BOY' },
  { c: '25785', m: "Tabio", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '27787', m: "Tadó", d: "Chocó", s: 'CO-CHO' },
  { c: '13780', m: "Talaigua Nuevo", d: "Bolívar", s: 'CO-BOL' },
  { c: '20787', m: "Tamalameque", d: "Cesar", s: 'CO-CES' },
  { c: '85400', m: "Támara", d: "Casanare", s: 'CO-CAS' },
  { c: '81794', m: "Tame", d: "Arauca", s: 'CO-ARA' },
  { c: '05789', m: "Támesis", d: "Antioquia", s: 'CO-ANT' },
  { c: '52786', m: "Taminango", d: "Nariño", s: 'CO-NAR' },
  { c: '52788', m: "Tangua", d: "Nariño", s: 'CO-NAR' },
  { c: '97666', m: "Taraira", d: "Vaupés", s: 'CO-VAU' },
  { c: '91798', m: "Tarapacá", d: "Amazonas", s: 'CO-AMA' },
  { c: '05790', m: "Tarazá", d: "Antioquia", s: 'CO-ANT' },
  { c: '41791', m: "Tarqui", d: "Huila", s: 'CO-HUI' },
  { c: '05792', m: "Tarso", d: "Antioquia", s: 'CO-ANT' },
  { c: '15790', m: "Tasco", d: "Boyacá", s: 'CO-BOY' },
  { c: '85410', m: "Tauramena", d: "Casanare", s: 'CO-CAS' },
  { c: '25793', m: "Tausa", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '41799', m: "Tello", d: "Huila", s: 'CO-HUI' },
  { c: '25797', m: "Tena", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '47798', m: "Tenerife", d: "Magdalena", s: 'CO-MAG' },
  { c: '25799', m: "Tenjo", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15798', m: "Tenza", d: "Boyacá", s: 'CO-BOY' },
  { c: '54800', m: "Teorama", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '41801', m: "Teruel", d: "Huila", s: 'CO-HUI' },
  { c: '41797', m: "Tesalia", d: "Huila", s: 'CO-HUI' },
  { c: '25805', m: "Tibacuy", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15804', m: "Tibaná", d: "Boyacá", s: 'CO-BOY' },
  { c: '15806', m: "Tibasosa", d: "Boyacá", s: 'CO-BOY' },
  { c: '25807', m: "Tibirita", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '54810', m: "Tibú", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '23807', m: "Tierralta", d: "Córdoba", s: 'CO-COR' },
  { c: '41807', m: "Timaná", d: "Huila", s: 'CO-HUI' },
  { c: '19807', m: "Timbío", d: "Cauca", s: 'CO-CAU' },
  { c: '19809', m: "Timbiquí", d: "Cauca", s: 'CO-CAU' },
  { c: '15808', m: "Tinjacá", d: "Boyacá", s: 'CO-BOY' },
  { c: '15810', m: "Tipacoque", d: "Boyacá", s: 'CO-BOY' },
  { c: '13810', m: "Tiquisio", d: "Bolívar", s: 'CO-BOL' },
  { c: '05809', m: "Titiribí", d: "Antioquia", s: 'CO-ANT' },
  { c: '15814', m: "Toca", d: "Boyacá", s: 'CO-BOY' },
  { c: '25815', m: "Tocaima", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25817', m: "Tocancipá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15816', m: "Togüí", d: "Boyacá", s: 'CO-BOY' },
  { c: '05819', m: "Toledo", d: "Antioquia", s: 'CO-ANT' },
  { c: '54820', m: "Toledo", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '68820', m: "Tona", d: "Santander", s: 'CO-SAN' },
  { c: '15820', m: "Tópaga", d: "Boyacá", s: 'CO-BOY' },
  { c: '25823', m: "Topaipí", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '19821', m: "Toribío", d: "Cauca", s: 'CO-CAU' },
  { c: '76823', m: "Toro", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '15822', m: "Tota", d: "Boyacá", s: 'CO-BOY' },
  { c: '19824', m: "Totoró", d: "Cauca", s: 'CO-CAU' },
  { c: '85430', m: "Trinidad", d: "Casanare", s: 'CO-CAS' },
  { c: '76828', m: "Trujillo", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '08832', m: "Tubará", d: "Atlántico", s: 'CO-ATL' },
  { c: '23815', m: "Tuchín", d: "Córdoba", s: 'CO-COR' },
  { c: '76834', m: "Tuluá", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '15001', m: "Tunja", d: "Boyacá", s: 'CO-BOY' },
  { c: '15832', m: "Tununguá", d: "Boyacá", s: 'CO-BOY' },
  { c: '52838', m: "Túquerres", d: "Nariño", s: 'CO-NAR' },
  { c: '13836', m: "Turbaco", d: "Bolívar", s: 'CO-BOL' },
  { c: '13838', m: "Turbaná", d: "Bolívar", s: 'CO-BOL' },
  { c: '05837', m: "Turbo", d: "Antioquia", s: 'CO-ANT' },
  { c: '15835', m: "Turmequé", d: "Boyacá", s: 'CO-BOY' },
  { c: '15837', m: "Tuta", d: "Boyacá", s: 'CO-BOY' },
  { c: '15839', m: "Tutazá", d: "Boyacá", s: 'CO-BOY' },
  { c: '25839', m: "Ubalá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25841', m: "Ubaque", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '76845', m: "Ulloa", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '15842', m: "Úmbita", d: "Boyacá", s: 'CO-BOY' },
  { c: '25845', m: "Une", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '27800', m: "Unguía", d: "Chocó", s: 'CO-CHO' },
  { c: '27810', m: "Unión Panamericana", d: "Chocó", s: 'CO-CHO' },
  { c: '05842', m: "Uramita", d: "Antioquia", s: 'CO-ANT' },
  { c: '50370', m: "Uribe", d: "Meta", s: 'CO-MET' },
  { c: '44847', m: "Uribia", d: "La Guajira", s: 'CO-LAG' },
  { c: '05847', m: "Urrao", d: "Antioquia", s: 'CO-ANT' },
  { c: '44855', m: "Urumita", d: "La Guajira", s: 'CO-LAG' },
  { c: '08849', m: "Usiacurí", d: "Atlántico", s: 'CO-ATL' },
  { c: '25851', m: "Útica", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '05854', m: "Valdivia", d: "Antioquia", s: 'CO-ANT' },
  { c: '23855', m: "Valencia", d: "Córdoba", s: 'CO-COR' },
  { c: '68855', m: "Valle de San José", d: "Santander", s: 'CO-SAN' },
  { c: '73854', m: "Valle de San Juan", d: "Tolima", s: 'CO-TOL' },
  { c: '86865', m: "Valle del Guamuez", d: "Putumayo", s: 'CO-PUT' },
  { c: '20001', m: "Valledupar", d: "Cesar", s: 'CO-CES' },
  { c: '05856', m: "Valparaíso", d: "Antioquia", s: 'CO-ANT' },
  { c: '18860', m: "Valparaíso", d: "Caquetá", s: 'CO-CAQ' },
  { c: '05858', m: "Vegachí", d: "Antioquia", s: 'CO-ANT' },
  { c: '68861', m: "Vélez", d: "Santander", s: 'CO-SAN' },
  { c: '73861', m: "Venadillo", d: "Tolima", s: 'CO-TOL' },
  { c: '05861', m: "Venecia", d: "Antioquia", s: 'CO-ANT' },
  { c: '25506', m: "Venecia", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15861', m: "Ventaquemada", d: "Boyacá", s: 'CO-BOY' },
  { c: '25862', m: "Vergara", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '76863', m: "Versalles", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '68867', m: "Vetas", d: "Santander", s: 'CO-SAN' },
  { c: '25867', m: "Vianí", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '17867', m: "Victoria", d: "Caldas", s: 'CO-CAL' },
  { c: '05873', m: "Vigía del Fuerte", d: "Antioquia", s: 'CO-ANT' },
  { c: '76869', m: "Vijes", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '54871', m: "Villa Caro", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '15407', m: "Villa de Leyva", d: "Boyacá", s: 'CO-BOY' },
  { c: '25843', m: "Villa de San Diego de Ubaté", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '54874', m: "Villa del Rosario", d: "Norte de Santander", s: 'CO-NSA' },
  { c: '19845', m: "Villa Rica", d: "Cauca", s: 'CO-CAU' },
  { c: '86885', m: "Villagarzón", d: "Putumayo", s: 'CO-PUT' },
  { c: '25871', m: "Villagómez", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '73870', m: "Villahermosa", d: "Tolima", s: 'CO-TOL' },
  { c: '17873', m: "Villamaría", d: "Caldas", s: 'CO-CAL' },
  { c: '13873', m: "Villanueva", d: "Bolívar", s: 'CO-BOL' },
  { c: '85440', m: "Villanueva", d: "Casanare", s: 'CO-CAS' },
  { c: '44874', m: "Villanueva", d: "La Guajira", s: 'CO-LAG' },
  { c: '68872', m: "Villanueva", d: "Santander", s: 'CO-SAN' },
  { c: '25873', m: "Villapinzón", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '73873', m: "Villarrica", d: "Tolima", s: 'CO-TOL' },
  { c: '50001', m: "Villavicencio", d: "Meta", s: 'CO-MET' },
  { c: '41872', m: "Villavieja", d: "Huila", s: 'CO-HUI' },
  { c: '25875', m: "Villeta", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25878', m: "Viotá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '15879', m: "Viracachá", d: "Boyacá", s: 'CO-BOY' },
  { c: '50711', m: "Vistahermosa", d: "Meta", s: 'CO-MET' },
  { c: '17877', m: "Viterbo", d: "Caldas", s: 'CO-CAL' },
  { c: '25885', m: "Yacopí", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '52885', m: "Yacuanquer", d: "Nariño", s: 'CO-NAR' },
  { c: '41885', m: "Yaguará", d: "Huila", s: 'CO-HUI' },
  { c: '05885', m: "Yalí", d: "Antioquia", s: 'CO-ANT' },
  { c: '05887', m: "Yarumal", d: "Antioquia", s: 'CO-ANT' },
  { c: '97889', m: "Yavaraté", d: "Vaupés", s: 'CO-VAU' },
  { c: '05890', m: "Yolombó", d: "Antioquia", s: 'CO-ANT' },
  { c: '05893', m: "Yondó", d: "Antioquia", s: 'CO-ANT' },
  { c: '85001', m: "Yopal", d: "Casanare", s: 'CO-CAS' },
  { c: '76890', m: "Yotoco", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '76892', m: "Yumbo", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '13894', m: "Zambrano", d: "Bolívar", s: 'CO-BOL' },
  { c: '68895', m: "Zapatoca", d: "Santander", s: 'CO-SAN' },
  { c: '47960', m: "Zapayán", d: "Magdalena", s: 'CO-MAG' },
  { c: '05895', m: "Zaragoza", d: "Antioquia", s: 'CO-ANT' },
  { c: '76895', m: "Zarzal", d: "Valle del Cauca", s: 'CO-VAC' },
  { c: '15897', m: "Zetaquira", d: "Boyacá", s: 'CO-BOY' },
  { c: '25898', m: "Zipacón", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '25899', m: "Zipaquirá", d: "Cundinamarca", s: 'CO-CUN' },
  { c: '47980', m: "Zona Bananera", d: "Magdalena", s: 'CO-MAG' },
];

export default MUNICIPIOS;
